import { render, staticRenderFns } from "./BooleanArgument.vue?vue&type=template&id=f89fe562&scoped=true&"
import script from "./BooleanArgument.vue?vue&type=script&lang=js&"
export * from "./BooleanArgument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89fe562",
  null
  
)

export default component.exports